import React from "react";
import { Button } from "@material-ui/core";

// styles
import useStyles from "./styles";

// components
import { Typography } from "../Wrappers";

export default function PageTitle(props) {
  var classes = useStyles();

  return (
    <div className={classes.pageTitleContainer}>
      <Typography className={classes.typo} variant="h1" size="sm">
        {props.title}
      </Typography>
      {props.button && (
        <Button
          disabled={props.iscustom && !props.buttonAllow}
          classes={{ root: classes.button }}
          variant="contained"
          size="large"
          onClick={props.modal}
          color="secondary"
        >
          {props.button}
        </Button>
      )}
    </div>
  );
}
